import { Box } from '@coolblue-development/becky';
import { Snackbar as FreddySnackbar, Loader } from '@coolblue-development/freddy';
import { EmailTopPanel } from './TopPanel/EmailTopPanel';
import EmailMessageItem from './Body/EmailMessageItem';
import PreviousEmailsAccordion from './PreviousEmailsAccordion';
import { useEmailContext } from '../../../../contexts/EmailContext';
import ReplyContainer from './Reply/ReplyContainer';
import OutboundEmailComposer from './Outbound/OutboundEmailComposer';
import { useSnackbar } from '../../../../utils/hooks/useSnackbar';

const EmailPage = (): JSX.Element => {
  const { emailThreads, selectedEmail, outboundContactId, isLoadingThread } = useEmailContext();
  const { snackbar, show, hideSnackbar } = useSnackbar();
  const emailThread = selectedEmail ? emailThreads[selectedEmail] : undefined;
  const isOutbound = selectedEmail !== null && selectedEmail === outboundContactId;
  const isSelectedThreadLoading = selectedEmail ? isLoadingThread(selectedEmail) : false;

  const messages = emailThread?.messages ?? [];
  const previousMessages = messages.slice(0, -1);
  const latestMessage = messages.length > 0 ? messages[messages.length - 1] : null;

  const handleAttachmentDownloadError = (): void => show('Failed to download attachment. Please try again.', 'error');

  return (
    <Box
      sx={{
        height: '100%',
        boxShadow: '0px 4px 16px 0px #246CB429',
        borderRadius: '12px',
        overflowY: 'auto',
        position: 'relative'
      }}
    >
      <EmailTopPanel />
      {isSelectedThreadLoading ? (
        <Loader />
      ) : (
        <Box sx={{ overflowY: 'auto' }}>
          <PreviousEmailsAccordion
            messages={previousMessages}
            onAttachmentDownloadError={handleAttachmentDownloadError}
          />
          {latestMessage && !(isOutbound && !latestMessage.bodyHtml) && (
            <EmailMessageItem
              key={latestMessage.contactId}
              message={latestMessage}
              index={messages.length - 1}
              initiallyCollapsed={false}
              onAttachmentDownloadError={handleAttachmentDownloadError}
            />
          )}
          {isOutbound ? (
            <OutboundEmailComposer
              onSendSuccess={() => show('Email sent successfully!', 'success')}
              onSendError={message => show(message, 'error')}
            />
          ) : (
            <ReplyContainer />
          )}
        </Box>
      )}

      <FreddySnackbar
        open={snackbar.open}
        title={snackbar.title}
        intent={snackbar.intent}
        duration={snackbar.duration}
        onClose={hideSnackbar}
        placement="bottom"
      />
    </Box>
  );
};

export default EmailPage;
